// extracted by mini-css-extract-plugin
export default {"tupacGrid":"fm-z","tupacHeader":"gm-z","tupacHeader2":"hm-z","tupacMenu":"im-z","tupacMenu2":"jm-z","tupacMain":"km-z","tupacMain2":"lm-z"};